// ----------------------------------------------------------------------------
// Sticky Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_sticky-bar.scss';

// -------------------------------------
// Variables
// -------------------------------------
const HEADER = document.querySelector('#shopify-section-header');
const STICKY_BAR = document.querySelector('#js--sticky-bar');

// Classes
const sticky_bar_active = 'js--sticky-bar-active'


// Function to check if header is scrolled past sign up bar
function isElementScrolledPast(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    return (rect.bottom < 0 || rect.top > windowHeight);
}

// Function to handle scroll events
function handleScroll(element) {
    document.body.classList.add(sticky_bar_active);

    if (isElementScrolledPast(HEADER)) {
        element.classList.add(sticky_bar_active);
    } else {
        element.classList.remove(sticky_bar_active);
    }
}

// Attach the scroll event listener
window.addEventListener('scroll', function() {
    if( STICKY_BAR !== null ) {
        handleScroll(STICKY_BAR);
    }
});

// Initial check on page load
document.addEventListener("DOMContentLoaded", function() {
    if( STICKY_BAR !== null ) {
        handleScroll(STICKY_BAR);
    }
});